module.exports = __webpack_public_path__ + "img/full_logo.a1b56b63.png";